import { ChangeDetectionStrategy, Component, Inject } from '@angular/core'
import { I18nService } from '../i18n.service'
import { WINDOW } from '@features/storage/window'
import { UpperCasePipe } from '@angular/common'
import { MatMenuModule } from '@angular/material/menu'
import { MatButton } from '@angular/material/button'

@Component({
    selector: 'app-language-selector',
    templateUrl: './language-selector.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatButton, MatMenuModule, UpperCasePipe]
})
export class LanguageSelectorComponent {

  constructor(private i18n: I18nService, @Inject(WINDOW) private readonly window: Window) { }

  changeLanguage(lang: string) {
    const prev = this.i18n.currentLanguage

    if (!this.i18n.changeLanguage(lang)) {
      return
    }

    const url = this.location.toString()
    this.location.replace(url.replace(`/${prev}`, `/${lang}`))
  }

  get currentLanguage(): string {
    return this.i18n.currentLanguage
  }

  get languages(): string[] {
    return this.i18n.languages
  }

  private get location (): Location {
    return this.window.location
  }
}
